export const GET_NOTE_PUSH_HINTS_TOOL_NAME = 'get_note_push_hints';
export const RECORD_NOTE_PUSH_HINTS_TOOL_NAME = 'record_note_push_hints';

export function deriveIsComputerUseNotePush(args: { toolName: string }): boolean {
  const name = args.toolName.toLowerCase();
  return (
    name === GET_NOTE_PUSH_HINTS_TOOL_NAME || name === RECORD_NOTE_PUSH_HINTS_TOOL_NAME
  );
}
